import { ArticleResult } from 'interface/article'

import {
  Box, BoxProps, Stack, Divider
} from "@mui/material"

import { Loading } from 'components/controls/loading'
import { ErrorBlock } from 'components/controls/errorInfo'

import { useArticlePreview } from './container'
import { ArticlePreviewHeader } from './components/header'
import { ArticlePreviewBody } from './components/body'
import { ArticlePreviewFooter } from './components/footer'

import { KojinPreviewDialog } from 'features/kojin/dialog/preview'
import { SisetuPreviewDialog } from 'features/sisetu/dialog/preview'

type ArticlePreviewProps = {
  articleList?: ArticleResult[]
  article?: ArticleResult
  articleId?: number
  targetSisetuCode?: string
  targetKojinCode?: string
  targetAuthorId?: number
  onSisetuOpenReply?: (sisetuCode: string | null) => void
  onKojinOpenReply?: (kojinCode: string | null) => void
  onAuthorOpenReply?: (authorId: number | null) => void
  onClose?: () => void
} & BoxProps
export const ArticlePreview = ({
  articleList,
  article: defaultArticle,
  articleId: defaultArticleId,
  targetSisetuCode,
  targetKojinCode,
  targetAuthorId,
  onSisetuOpenReply,
  onKojinOpenReply,
  onAuthorOpenReply,
  onClose,
  ...others
}: ArticlePreviewProps) => {
  const container = useArticlePreview({
    articleList,
    article: defaultArticle,
    articleId: defaultArticleId,
    targetSisetuCode,
    targetKojinCode,
    targetAuthorId,
    onSisetuOpenReply,
    onKojinOpenReply,
    onAuthorOpenReply,
    onClose
  })
  const {
    loading, error, article,
    /*onSisetuOpen,*/ selectedSisetuCode, sisetuList,
    /*onKojinOpen,*/ selectedKojinCode, kojinList,
    /*onAuthorOpen,*/ selectedAuthorId,
    closeModal
  } = container

  return (
    <>
      <Box {...others}>
        {loading && <Loading/>}
        <ErrorBlock error={error}/>

        {article && (
          <Stack direction="column" sx={{ height: '100%', boxSizing: 'border-box' }}>
            <ArticlePreviewHeader article={article} container={container}/>
            <Divider/>
            <ArticlePreviewBody article={article} container={container}/>
            <Divider/>
            <ArticlePreviewFooter article={article} container={container}/>
          </Stack>
        )}
      </Box>
      {selectedSisetuCode ? (
        <SisetuPreviewDialog
          sisetuList={sisetuList}
          sisetuCode={selectedSisetuCode}
          onClose={closeModal}
        />
      ) : (selectedKojinCode || selectedAuthorId) ? (
        <KojinPreviewDialog
          kojinList={kojinList}
          kojinCode={selectedKojinCode}
          authorId={selectedAuthorId}
          onClose={closeModal}
        />
      ) : <></>}
    </>
  )
}
